import { UAT_MARKER } from './constants';

export const isUATEnv = () => {
  const url = window.location.href;

  return url.includes(UAT_MARKER);
};

export const isDevEnv = () => {
  return !!process.env.NODE_ENV && process.env.NODE_ENV === 'development';
};

export const isTestingEnv = () => {
  return isDevEnv() || isUATEnv();
};
